module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-3.8168591f.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/radiance/radiance-3.png
// module id = 2686
// module chunks = 11